import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.exerciseComponentName), _mergeProps(_ctx.$props, {
    onUpdateSubmission: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('updateSubmission', $event))),
    onRunCode: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('runCode'))),
    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('blur')))
  }), null, 16))
}